export default "__VITE_ASSET__ZBwL4rDR__"